// const theme = (contextTheme.palette.secondary['-300']) ? contextTheme : mainTheme

/**
 * @param {object} theme
 */
const styles = (theme) => {
    const { colors } = theme['foundations-library']
    return {
        wrapper: {
            position: 'relative',
            width: '100%',
            marginBottom: 40,
            // height: 'calc(100% - 60px)',
            // display: 'flex',
            // flexDirection: 'column',
            '& > .content': {
                maxWidth: '1000px',
                alignItems: 'center',
                gap: '40px',
                padding: '20px',
                borderRadius: '10px',
                border: `1px solid ${colors.neutral[100]}`,
                margin: '0 auto',
                // flex: 1,
                // overflowY: 'auto',
                // paddingBottom: 30,
                '& .titles': {
                    // display: 'flex',
                    // flexDirection: 'column',
                    // alignItems: 'center',
                    // color: theme.palette.text.primary,
                    // '& .subtitle': {
                    //     textAlign: 'center',
                    //     width: 538
                    // }
                }
            },
            '& > .stepper-wrapper': {
                marginBottom: 40,
                '& div:first-of-type': {
                    maxWidth: 'fit-content',
                    margin: '0 auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                '& div:nth-child(even)': {
                    display: 'flex',
                    '& span': {
                        width: 100,
                        margin: '15px auto'
                    }
                },
                '& div:nth-child(odd)': {
                    maxWidth: 30,
                    '&:has(.active)': {
                        maxWidth: 44,
                        maxHeight: 44
                    }
                },
                '& .active > .icon-container': {
                    '& div:first-of-type': {
                        color: 'white',
                        background: colors.primary[500],
                        maxWidth: 44
                    }
                }
                // margin: 50,
                // textAlign: 'center',
                // '@media (max-width: 600px)': {
                //     margin: 24,
                // },
                // '& .MuiMobileStepper-no-padding': {
                //     padding: 0
                // }
            }
            // '&.mobile': {
            //     '& > .content': {
            //         overflowY: 'auto',
            //         '& .titles': {
            //             marginBottom: 30,
            //             color: theme.palette.text.primary,
            //             '& .title': {
            //                 marginBottom: 10,
            //                 width: '100%'
            //             }
            //         }
            //     },
            //     '& > .stepper-wrapper': {
            //         margin: '15px 0'
            //     }
            // },
            // '& .MuiStep-root': {
            //     paddingTop: 12
            // },
            // '& .bottom-navigation': {
            //     position: 'absolute',
            //     left: 0,
            //     bottom: 0,
            //     right: 0
            // }
        },
        buttonsContainer: {
            maxWidth: 1000,
            width: '100%',
            margin: '40px auto',
            display: 'flex',
            justifyContent: 'end',
            gap: 20
        },
        nextBtn: {
            width: 155
        }
    }
}

export default styles
